import { render, staticRenderFns } from "./patent-Sharing.vue?vue&type=template&id=9f3909ee&scoped=true&"
import script from "./patent-Sharing.vue?vue&type=script&lang=js&"
export * from "./patent-Sharing.vue?vue&type=script&lang=js&"
import style0 from "./patent-Sharing.vue?vue&type=style&index=0&id=9f3909ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3909ee",
  null
  
)

export default component.exports